<template>
    <div class="mb-sm-0 sec-footer-wrap" style="line-height: 1; background-color :white;">
        <div class="sec-footer">
                            <div class="mod-description">
    <p class="mod-description__logo">
        <img :src="`${lifull_homes}?v=b65a3064b0aa1dde3689b66dce06e524`" alt="LIFULL HOME'S" width="240" height="81">
        </p>
    <p class="mod-description__description">不動産売買・住宅情報の総合サイト【LIFULL HOME'S/ライフルホームズ】賃貸[賃貸マンション・アパート・一戸建て]から購入[新築マンション・中古マンション・新築一戸建て・中古一戸建て・土地]、家の建築[注文住宅]、リノベーション、不動産投資など、不動産の購入や売却に関するあらゆるご要望におこたえします。LIFULLによる定期的なキャンペーンもお届けします。全国の住宅情報が満載の不動産・住宅情報サイト【LIFULL HOME'S/ライフルホームズ】 物件情報管理責任者：山田 貴士（株式会社LIFULL 取締役執行役員）</p>
</div>

                            <div class="mod-extraLinks" id="prg-extraLinks">
    <ul class="mod-extraLinks__items">
        <li class="mod-extraLinks__item">
            <h2 class="mod-extraLinks__accordionLabel prg-is-selectable" title="全国の地域から不動産・住宅を探す"  @touchstart="Select('top')" :class="{'is-selected': is_top_selected}">全国の地域から不動産・住宅を探す</h2>
            <div class="mod-extraLinks__accordionContainer">
                <dl class="mod-extraLinks__areas">
                                            <div class="mod-extraLinks__area">
                            <dt class="mod-extraLinks__areaName">
                                <a href="https://www.homes.co.jp/tohoku/">北海道・東北</a>
                            </dt>
                            <dd class="mod-extraLinks__linksWrapper">
                                <ul class="mod-extraLinks__links">
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/hokkaido/">北海道</a>
                                                                                    (<a href="https://www.homes.co.jp/hokkaido/sapporo/">札幌市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/aomori/">青森</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/iwate/">岩手</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/miyagi/">宮城</a>
                                                                                    (<a href="https://www.homes.co.jp/miyagi/sendai/">仙台市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/akita/">秋田</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/yamagata/">山形</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/fukushima/">福島</a>
                                                                            </li>
                                                                </ul>
                            </dd>
                        </div>
                                            <div class="mod-extraLinks__area">
                            <dt class="mod-extraLinks__areaName">
                                <a href="https://www.homes.co.jp/kanto/">関東</a>
                            </dt>
                            <dd class="mod-extraLinks__linksWrapper">
                                <ul class="mod-extraLinks__links">
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/tokyo/">東京</a>
                                                                                    (<a href="https://www.homes.co.jp/tokyo/23ku/">東京23区</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/kanagawa/">神奈川</a>
                                                                                    (<a href="https://www.homes.co.jp/kanagawa/yokohama/">横浜市</a>・<a href="https://www.homes.co.jp/kanagawa/kawasaki/">川崎市</a>・<a href="https://www.homes.co.jp/kanagawa/sagamihara/">相模原市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/saitama/">埼玉</a>
                                                                                    (<a href="https://www.homes.co.jp/saitama/saitama/">さいたま市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/chiba/">千葉</a>
                                                                                    (<a href="https://www.homes.co.jp/chiba/chiba/">千葉市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/ibaraki/">茨城</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/tochigi/">栃木</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/gunma/">群馬</a>
                                                                            </li>
                                                                </ul>
                            </dd>
                        </div>
                                            <div class="mod-extraLinks__area">
                            <dt class="mod-extraLinks__areaName">
                                <a href="https://www.homes.co.jp/hokuriku/">北陸・甲信越</a>
                            </dt>
                            <dd class="mod-extraLinks__linksWrapper">
                                <ul class="mod-extraLinks__links">
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/niigata/">新潟</a>
                                                                                    (<a href="https://www.homes.co.jp/niigata/niigata/">新潟市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/toyama/">富山</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/ishikawa/">石川</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/fukui/">福井</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/yamanashi/">山梨</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/nagano/">長野</a>
                                                                            </li>
                                                                </ul>
                            </dd>
                        </div>
                                            <div class="mod-extraLinks__area">
                            <dt class="mod-extraLinks__areaName">
                                <a href="https://www.homes.co.jp/tokai/">東海</a>
                            </dt>
                            <dd class="mod-extraLinks__linksWrapper">
                                <ul class="mod-extraLinks__links">
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/aichi/">愛知</a>
                                                                                    (<a href="https://www.homes.co.jp/aichi/nagoya/">名古屋市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/gifu/">岐阜</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/shizuoka/">静岡</a>
                                                                                    (<a href="https://www.homes.co.jp/shizuoka/shizuoka/">静岡市</a>・<a href="https://www.homes.co.jp/shizuoka/hamamatsu/">浜松市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/mie/">三重</a>
                                                                            </li>
                                                                </ul>
                            </dd>
                        </div>
                                            <div class="mod-extraLinks__area">
                            <dt class="mod-extraLinks__areaName">
                                <a href="https://www.homes.co.jp/kinki/">近畿</a>
                            </dt>
                            <dd class="mod-extraLinks__linksWrapper">
                                <ul class="mod-extraLinks__links">
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/osaka/">大阪</a>
                                                                                    (<a href="https://www.homes.co.jp/osaka/sakai/">堺市</a>・<a href="https://www.homes.co.jp/osaka/osaka/">大阪市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/hyogo/">兵庫</a>
                                                                                    (<a href="https://www.homes.co.jp/hyogo/kobe/">神戸市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/kyoto/">京都</a>
                                                                                    (<a href="https://www.homes.co.jp/kyoto/kyoto/">京都市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/shiga/">滋賀</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/nara/">奈良</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/wakayama/">和歌山</a>
                                                                            </li>
                                                                </ul>
                            </dd>
                        </div>
                                            <div class="mod-extraLinks__area">
                            <dt class="mod-extraLinks__areaName">
                                <a href="https://www.homes.co.jp/chugoku/">中国・四国</a>
                            </dt>
                            <dd class="mod-extraLinks__linksWrapper">
                                <ul class="mod-extraLinks__links">
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/tottori/">鳥取</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/shimane/">島根</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/okayama/">岡山</a>
                                                                                    (<a href="https://www.homes.co.jp/okayama/okayama/">岡山市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/hiroshima/">広島</a>
                                                                                    (<a href="https://www.homes.co.jp/hiroshima/hiroshima/">広島市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/yamaguchi/">山口</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/tokushima/">徳島</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/kagawa/">香川</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/ehime/">愛媛</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/kochi/">高知</a>
                                                                            </li>
                                                                </ul>
                            </dd>
                        </div>
                                            <div class="mod-extraLinks__area">
                            <dt class="mod-extraLinks__areaName">
                                <a href="https://www.homes.co.jp/kyushu/">九州・沖縄</a>
                            </dt>
                            <dd class="mod-extraLinks__linksWrapper">
                                <ul class="mod-extraLinks__links">
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/fukuoka/">福岡</a>
                                                                                    (<a href="https://www.homes.co.jp/fukuoka/fukuoka/">福岡市</a>・<a href="https://www.homes.co.jp/fukuoka/kitakyushu/">北九州市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/saga/">佐賀</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/nagasaki/">長崎</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/kumamoto/">熊本</a>
                                                                                    (<a href="https://www.homes.co.jp/kumamoto/kumamoto/">熊本市</a>)
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/oita/">大分</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/miyazaki/">宮崎</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/kagoshima/">鹿児島</a>
                                                                            </li>
                                                                    <li class="mod-extraLinks__link">
                                        <a href="https://www.homes.co.jp/okinawa/">沖縄</a>
                                                                            </li>
                                                                </ul>
                            </dd>
                        </div>
                                    </dl>
            </div>
        </li>
        <li class="mod-extraLinks__item">
            <h2 class="mod-extraLinks__accordionLabel prg-is-selectable" title="LIFULLのサービスから探す" @touchstart="Select('bottom')" :class="{'is-selected': is_bottom_selected}">LIFULLのサービスから探す</h2>
            <div class="mod-extraLinks__accordionContainer">
                <dl class="mod-extraLinks__services">
                    <div class="mod-extraLinks__service">
                        <dt class="mod-extraLinks__serviceName">LIFULL HOME'Sのサービス</dt>
                        <dd class="mod-extraLinks__servicesWrapper">
                            <ul class="mod-extraLinks__links">
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/">不動産・住宅</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/mansion/">マンション</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/kodate/">一戸建て</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/iezukuri/">注文住宅</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/renovation/">リノベーション</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/satei/">不動産売却査定</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://toushi-test.homes.co.jp/">不動産投資</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/callcenter/">アドバイザー</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/counter/">住まいの窓口</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/loan/">住宅ローン</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://lifullhomes-index.jp/">住まいインデックス</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/price-map/">プライスマップ</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/archive/">不動産アーカイブ</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/akiyabank/">空き家バンク</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/price/">家賃相場</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/realtor/">不動産会社</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/machimusubi/">まちむすび</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/life/">LIFE LIST</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/words/">不動産用語集</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/cont/">住まいのお役立ち情報</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/cont/press/">LIFULL HOME'S PRESS</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/app/">アプリ</a>
                                </li>
                            </ul>
                        </dd>
                    </div>
                    <div class="mod-extraLinks__service">
                        <dt class="mod-extraLinks__serviceName">物件の種類</dt>
                        <dd class="mod-extraLinks__servicesWrapper">
                            <ul class="mod-extraLinks__links">
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/">賃貸</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/mansion/" rel="nofollow">賃貸マンション</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/apartment/" rel="nofollow">アパート</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/kodate/">賃貸一戸建て</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/mansion/shinchiku/">新築マンション</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/mansion/chuko/">中古マンション</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/kodate/shinchiku/">新築一戸建て</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/kodate/chuko/">中古一戸建て</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/tochi/">土地</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/tochi/">貸土地</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/parking/">月極駐車場</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/tempo/">貸店舗</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/tempo/">店舗</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/office/">貸事務所</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/office/">事務所</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/soko/">貸倉庫・貸工場</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/soko/">倉庫・工場</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/chintai/other/">その他(賃貸)</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/other/">その他</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://monthly.homes.jp/" target="_blank">マンスリーマンション</a>
                                </li>
                            </ul>
                        </dd>
                    </div>
                    <div class="mod-extraLinks__service">
                        <dt class="mod-extraLinks__serviceName">LIFULLのサービス</dt>
                        <dd class="mod-extraLinks__servicesWrapper">
                            <ul class="mod-extraLinks__links">
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/">不動産・住宅</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/hikkoshi/">引越し</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/trunkroom/">トランクルーム</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://www.homes.co.jp/rentalspace/">レンタルスペース</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://kaigo.homes.co.jp/" target="_blank">老人ホーム</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://local.lifull.jp/" target="_blank">地方創生</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="https://flower.lifull.jp/" target="_blank">花の定期便</a>
                                </li>
                                <li class="mod-extraLinks__link">
                                    <a href="http://lifull-fam.com/" target="_blank">ママの就労支援</a>
                                </li>
                            </ul>
                        </dd>
                    </div>
                </dl>
            </div>
        </li>
    </ul>
</div>

                            <div class="mod-securityArea">
    <p class="mod-securityArea__heading">
        LIFULL HOME'Sは安心・安全のための取り組みを行っています
    </p>
    <ul class="mod-securityArea__items">
        <li class="mod-securityArea__item">
            <a href="http://www.rsc-web.jp/nsp/sw_homes.html" class="mod-securityArea__infoImage" target="_blank" rel="noopener">
                <img :src="`${img_realtorCouncil_2019}?v=dac05332d23bdb7c0c0cfe0a9422cbc9`" width="62" height="62" alt="不動産情報サイト事業者連絡協議会">
            </a>
            <dl class="mod-securityArea__info--realtor">
                <dt class="mod-securityArea__infoLabel">信頼できる物件情報サイトNo.1を目指して</dt>
                <dd>
                    このサイトは「不動産情報サイト事業者連絡協議会」が定める情報公開の自主規制ルールに則ったサイトとして承認されています。
                </dd>
            </dl>
        </li>
        <li class="mod-securityArea__item">
            <figure class="mod-securityArea__infoImage">
                <img :src="`${img_iso_2019}`" width="130" height="60" alt="情報セキュリティマネジメントシステム国際規格">
            </figure>
            <dl class="mod-securityArea__info--iso">
                <dt class="mod-securityArea__infoLabel">すべての情報を適切に取り扱うために</dt>
                <dd>
                    株式会社LIFULLは、情報セキュリティマネジメントシステムの国際規格「ISO/IEC 27001」および国内規格「JIS Q 27001」の認証を取得しています。
                </dd>
            </dl>
        </li>
    </ul>
</div>
                    </div>
    </div>
</template>

<script>
import lifull_homes from "../assets/lifull_homes.svg";
import img_iso_2019 from "../assets/img_iso_2019.png";
import img_realtorCouncil_2019 from "../assets/img_realtorCouncil_2019.png";
export default {
    data(){
        return{
          lifull_homes,
          img_iso_2019,
          img_realtorCouncil_2019,
          is_top_selected: false,
          is_bottom_selected: false
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
      Select(type){
        if (type === 'top') this.is_top_selected = !this.is_top_selected;
        if (type === 'bottom') this.is_bottom_selected = !this.is_bottom_selected;
      }
    }
}
</script>

<style scoped>
.v-application p {
    margin-bottom: 0px !important;
}
ol,
ul {
  list-style: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

img {
  vertical-align: bottom;
}

label {
  cursor: pointer;
}
.sec-footerContents {
  background-color: #fff;
}

.sec-footer {
  padding: 10px 10px 8px;
  max-width: 948px;
  min-width: 320px;
  margin: 0 calc(50% - 50vw);
  width: 100vw;
  /*margin: 0 auto;*/
  box-sizing: border-box;
  font-family: "LIFULLFONT-Regular", "游ゴシック体", "YuGothic", "游ゴシック",
    "Yu Gothic", "メイリオ", "Meiryo", sans-serif !important;
}
@media only screen and (min-width: 769px) {
  .sec-footer {
    padding: 40px 4px 40px;
    width: 100%;
    margin: 0 auto;
  }
}
.mod-description {
  display: none;
}
@media only screen and (min-width: 769px) {
  .mod-description {
    display: flex;
  }
}
.mod-description:not(:first-child) {
  margin-top: 40px;
}
.mod-description__logo {
  flex-shrink: 0;
}
.mod-description__description {
  margin-left: 40px;
  padding-top: 10px;
  font-size: 12px;
  line-height: 1.4;
}
.mod-extraLinks {
  margin: 0 -10px;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks {
    margin: 0;
  }
  .mod-extraLinks:not(:first-child) {
    margin-top: 30px;
  }
}
.mod-extraLinks__items {
  display: flex;
  flex-direction: column;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__items {
    margin: 0;
    flex-direction: row;
  }
}
.mod-extraLinks__item {
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  flex: 1;
}
.mod-extraLinks__item + .mod-extraLinks__item {
  margin-top: -1px;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__item {
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    flex: 3;
  }
  .mod-extraLinks__item + .mod-extraLinks__item {
    flex: 2;
    margin: 0 0 0 28px;
  }
}
.mod-extraLinks__accordionLabel {
  font-weight: bold;
  font-size: 16px;
  font-family: "LIFULLFONT-Bold", "游ゴシック体", "YuGothic", "游ゴシック",
    "Yu Gothic", "メイリオ", "Meiryo", sans-serif;
  position: relative;
  padding: 15px 10px;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__accordionLabel {
    display: none;
  }
}
.mod-extraLinks__accordionLabel::after {
  position: absolute;
  top: 0;
  right: 10px;
  bottom: 0;
  left: auto;
  content: "";
  width: 1em;
  height: 1em;
  margin: auto;
  background: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22120%22%20height%3D%22120%22%20viewBox%3D%220%200%20120%20120%22%3E%3Cg%20fill%3D%22%236c6c6c%22%3E%3Cpath%20d%3D%22M99.6%2C46.9l-4.2-4.2c-1.6-1.6-4.1-1.6-5.7%2C0l-26.9%2C26.8c-1.6%2C1.6-4.1%2C1.6-5.7%2C0l-26.8-26.8c-1.6-1.6-4.1-1.6-5.7%2C0l-4.2%2C4.2c-1.6%2C1.6-1.6%2C4.1%2C0%2C5.7l36.8%2C36.8c.8.8%2C1.8%2C1.2%2C2.8%2C1.2%2C1%2C0%2C2.1-.4%2C2.8-1.2l36.8-36.8c1.6-1.6%2C1.6-4.1%2C0-5.7z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E")
    no-repeat 50% 50%;
  background-size: 1em;
}
.mod-extraLinks__accordionLabel.is-selected::after {
  background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22120%22%20height%3D%22120%22%20viewBox%3D%220%200%20120%20120%22%3E%3Cg%20fill%3D%22%236c6c6c%22%3E%3Cpath%20d%3D%22M57.3%2C30.3l-36.2%2C36.1c-1.5%2C1.5-1.5%2C4%2C0%2C5.5l5.7%2C5.7c1.5%2C1.5%2C4%2C1.5%2C5.5%2C0l24.9-24.9c1.5-1.5%2C4-1.5%2C5.5%2C0l24.9%2C24.9c1.5%2C1.5%2C4%2C1.5%2C5.5%2C0l5.8-5.7c1.5-1.5%2C1.5-4%2C0-5.5l-36.2-36.1c-1.5-1.5-3.9-1.5-5.4%2C0z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E");
}
.mod-extraLinks__accordionLabel.is-selected
  + .mod-extraLinks__accordionContainer {
  display: block;
}
.mod-extraLinks__accordionContainer {
  display: none;
  padding: 5px 15px 10px;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__accordionContainer {
    display: block;
    padding: 20px;
  }
}
.mod-extraLinks__area {
  display: flex;
  flex-direction: column;
}
.mod-extraLinks__area + .mod-extraLinks__area {
  margin-top: 18px;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__area {
    flex-direction: row;
  }
  .mod-extraLinks__area + .mod-extraLinks__area {
    margin-top: 10px;
  }
}
.mod-extraLinks__areaName {
  width: 5.5em;
  flex-shrink: 0;
}
.mod-extraLinks__areaName a {
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__areaName a {
    font-size: 11px;
    font-weight: normal;
    text-decoration: underline;
  }
}
.mod-extraLinks__prefsWrapper {
  margin-top: 10px;
  overflow: hidden;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__prefsWrapper {
    margin: 0 0 0 10px;
  }
}
.mod-extraLinks__service + .mod-extraLinks__service {
  margin-top: 20px;
}
.mod-extraLinks__services {
  font-size: 12px;
}
.mod-extraLinks__serviceName {
  font-weight: bold;
  font-family: "LIFULLFONT-Bold", "游ゴシック体", "YuGothic", "游ゴシック",
    "Yu Gothic", "メイリオ", "Meiryo", sans-serif;
  padding-bottom: 3px;
  font-size: 13px;
}
.mod-extraLinks__servicesWrapper {
  overflow: hidden;
  margin-top: 10px;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__servicesWrapper {
    margin: 10px -7px 0;
  }
}
.mod-extraLinks__links {
  flex: 1;
  margin: -10px 0 0 -8px;
  display: inline-flex;
  flex-wrap: wrap;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__links {
    margin-left: -1px;
  }
}
.mod-extraLinks__linksWrapper {
  margin-top: 10px;
  overflow: hidden;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__linksWrapper {
    margin: 0 0 0 -1px;
  }
}
.mod-extraLinks__link {
  margin-top: 10px;
  padding: 0 7px;
  border-left: 1px solid #000;
  font-size: 12px;
}
@media only screen and (min-width: 769px) {
  .mod-extraLinks__link {
    font-size: 11px;
  }
}
.mod-extraLinks a {
  color: inherit;
}
.mod-extraLinks a:hover {
  color: #ed6103;
}

.mod-securityArea {
  font-size: 12px;
}
.mod-securityArea:not(:first-child) {
  margin-top: 30px;
}
@media only screen and (min-width: 769px) {
  .mod-securityArea:not(:first-child) {
    margin-top: 40px;
  }
}
.mod-securityArea__heading {
  font-weight: bold;
  font-family: "LIFULLFONT-Bold", "游ゴシック体", "YuGothic", "游ゴシック",
    "Yu Gothic", "メイリオ", "Meiryo", sans-serif;
  background-color: #f7f7f7;
  padding: 10px;
  line-height: 1.5;
  text-align: center;
}
.mod-securityArea__items {
  margin-top: 20px;
  display: flex;
}
.mod-securityArea__item {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-top: 6px;
  line-height: 1.6;
}
.mod-securityArea__item + .mod-securityArea__item {
  border-left: 1px solid #d8d8d8;
  padding-left: 10px;
  margin-left: 10px;
}
@media only screen and (min-width: 769px) {
  .mod-securityArea__item {
    padding: 0;
    flex-direction: row;
  }
  .mod-securityArea__item + .mod-securityArea__item {
    border-left: none;
    margin-left: 40px;
  }
}
.mod-securityArea__infoImage {
  height: 62px;
  margin: 0 0 15px 0;
  text-align: center;
}
@media only screen and (min-width: 769px) {
  .mod-securityArea__infoImage {
    margin: 0 20px 0 0;
  }
}
.mod-securityArea__infoLabel {
  font-weight: bold;
  font-family: "LIFULLFONT-Bold", "游ゴシック体", "YuGothic", "游ゴシック",
    "Yu Gothic", "メイリオ", "Meiryo", sans-serif;
}
@media only screen and (min-width: 769px) {
  .mod-securityArea__infoLabel {
    margin-bottom: 4px;
  }
}
.v-application ul {
    padding-left: 0px;
}
</style>